import React, { useEffect, useState } from "react";
import InputTextField from "../../../../components/input/inputTextField";
import TableCustom from "../../../../components/table/tableCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { useDispatch, useSelector } from "react-redux";
import {
  NavigateFunction,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { FiberManualRecord, RemoveRedEyeOutlined, SearchOutlined } from "@mui/icons-material";
import { debouncedApiCall } from "../../../../utils/app.utils";
import { routeName } from "../../../../routes/routeName";
import { advisorEstimateScoreApi } from "../../../../api/advisor-estimate-score/advisor-estimate.api";
import NavigateListCustom from "../../../../components/navigation/NavigationListCustom";
import ContentHeading from "../../../../components/layout/content/ContentHeading";
import { ButtonOutlined } from "../../../../components/button/ButtonCustoms";
import { alertError } from "../../../../components/alert/swal";
import { dateToView } from "../../../../utils/date.utils";
import CustomStatus from "../../../../components/chip/CustomStatus";
import { getEnumValue } from "../../../../utils/common";
import { ADVISOR_ESTIMATE } from "../../../../domains/enum/estimate";

type Props = {};

const EvaluationScoresFromStudentsDetail: React.FC<Props> = (props: Props) => {
  const navigate: NavigateFunction = useNavigate();
  const { profile } = useSelector((state: any) => state.profile);
  const { id } = useParams();

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const prop_year = queryParams.get("year");
  const prop_term = queryParams.get("term");

  const [data, setData] = useState<any[]>([]);

  const [search, setSearch] = useState<string>("");

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");
  const handleRequestSort = (sortBy: string, sortType: string) => {
    setSortBy(sortBy);
    setSortType(sortType);
  };

  const getData = async (id: number, id_employee: number) => {
    try {
      if (!id_employee || !id) {
        return;
      }

      let query: any = {
        page: page,
        limit: pageLimit,
        sortBy: sortBy,
        sortType: sortType,
        keyword: search ?? "",
      };

      const res =
        await advisorEstimateScoreApi.getCourseAnnualEmployeeByIdCourseOfStudyAndIdEmployee(
          +id,
          +id_employee,
          query
        );
      const data = res.data;
      if (data.status < 300) {
        setData(res.data?.data?.items ?? []);
        setTotalItems(res.data?.data?.meta?.totalItems || 0);
      } else {
        setData([]);
      }
    } catch (error) { }
  };

  const headCells = [
    {
      id: "course_name",
      width: 150,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชื่อรายวิชา",
    },
    {
      id: "course_no",
      width: 125,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "รหัสวิชา",
    },
    {
      id: "year",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "ชั้นปีที่สอน",
    },
    // {
    //   id: "teacher",
    //   width: 100,
    //   sortable: false,
    //   disablePadding: false,
    //   align: "start",
    //   label: "อาจารย์ผู้สอน",
    // },
    {
      id: "score",
      width: 100,
      sortable: false,
      disablePadding: false,
      align: "center",
      label: "คะแนนเฉลี่ย",
    },
        {
      id: "start_date",
      disablePadding: false,
      width: 100,
      sortable: false,
      align: "start",
      label: "วันที่เริ่มต้นเปิดให้ประเมิน",
    },
    {
      id: "end_date",
      disablePadding: false,
      width: 100,
      sortable: false,
      align: "start",
      label: "วันที่สิ้นสุดเปิดให้ประเมิน",
    },
    {
      id: "status",
      disablePadding: false,
      width: 100,
      sortable: false,
      align: "start",
      label: "สถานะ",
    },
    {
      id: "action",
      width: 50,
      sortable: false,
      disablePadding: false,
      align: "start",
      label: "",
    },
  ];

  // study_day 0 === อาทิด
  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_courses,
      courses_name,
      courses_no,
      academic_year,
      id_employee,
      full_name,
      buddhist_name,
      employee_no,
      points,
      id_course_annual,
      id_course_annual_employee,
      estimate_start_date,
      estimate_end_date,
      estimate_status
    } = objData;

    const objRenderData = {
      key: id_course_annual_employee,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: courses_name ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: courses_no ?? "-",
        },
        {
          option: "TEXT",
          align: "start",
          label: academic_year ?? "-",
        },
        // {
        //   option: "TEXT",
        //   align: "start",
        //   label: full_name ?? "-",
        // },
        {
          option: "TEXT",
          align: "center",
          label: parseFloat(points).toFixed(1) ?? "0",
        },
        {
          option: "TEXT",
          align: "start",
          label: estimate_start_date
            ? dateToView(estimate_start_date)
            : estimate_start_date,
        },
        {
          option: "TEXT",
          align: "start",
          label: estimate_end_date
            ? dateToView(estimate_end_date)
            : estimate_end_date,
        },
        {
          option: "COMPONENT",
          align: "start",
          component: (
            <CustomStatus
              label={
                getEnumValue(ADVISOR_ESTIMATE, estimate_status) ||
                "Unknown status"
              }
              type="outlined"
              color={
                estimate_status === ADVISOR_ESTIMATE.OPEN_FOR_ESTIMATE ||
                  estimate_status === ADVISOR_ESTIMATE.START_FOR_ESTIMATE
                  ? "success"
                  : estimate_status === ADVISOR_ESTIMATE.NOT_START_YET
                    ? "warning"
                    : "error"
              }
              icon={<FiberManualRecord />}
              width="250px"
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <>
              <RemoveRedEyeOutlined
                onClick={() => {
                  if (parseFloat(points).toFixed(1) === "0.0") {
                    alertError("ยังไม่มีคะแนนประเมิน")
                  } else {
                    navigate(
                      routeName.advisor.EvaluationScoresFromStudents +
                      `/${id_course_annual_employee}/estimate-detail?year=${prop_year}&term=${prop_term}&id_course_of_study=${id}&course=${`รหัสวิชา : ${courses_no} / ชื่อรายวิชา : ${courses_name}`}`
                    );
                  }
                }}
                style={{
                  cursor: "pointer",
                }}
              />
            </>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  useEffect(() => {
    if (id && profile && profile?.id_employee) {
      getData(+id, +profile.id_employee);
    }
  }, [page, pageLimit, sortBy, sortType, search, id, profile]);

  return (
    <div>
      <NavigateListCustom
        navigateData={[
          {
            name: `คะแนนประเมินจากนักศึกษา`,
            key: "1",
            pathName: routeName.advisor.EvaluationScoresFromStudents,
            onClick: () =>
              navigate(`${routeName.advisor.EvaluationScoresFromStudents}`),
          },
          {
            name: `คะแนนประเมินจากนักศึกษา ปีการศึกษา ${prop_year} ภาคเรียนที่ ${prop_term}`,
            key: "2",
            pathName: "",
          },
        ]}
      />

      <ContentHeading
        title={`คะแนนประเมินจากนักศึกษา ปีการศึกษา ${prop_year} ภาคเรียนที่  ${prop_term}`}
        detail="กรุณาเลือกรายการที่ท่านต้องการ"
      />

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-3">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder="ค้นหาชื่อวิชา/รหัสวิชา"
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={1940}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={handleRequestSort}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>

      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        <ButtonOutlined
          onClick={() => navigate(-1)}
          mode="del"
          buttonName="ย้อนกลับ"
        />
      </div>
    </div>
  );
};

export default EvaluationScoresFromStudentsDetail;
